'use client';

import { useState, useCallback } from 'react';
import { useChatContext } from './ChatContext';
import ChatButton from './ui/ChatButton';
import ChatWindow from './ui/ChatWindow';

interface ChatWidgetProps {
  logoUrl: string;
}

/**
 * ChatWidget using unified context
 * - Uses unified ChatContext for all state management
 */
export function ChatWidget({ logoUrl }: ChatWidgetProps) {
  const { isOpen, toggleChat } = useChatContext();
  const [showDisclaimer, setShowDisclaimer] = useState(true);

  const handleDismissDisclaimer = useCallback(() => {
    setShowDisclaimer(false);
  }, []);

  return (
    <>
      <ChatButton isOpen={isOpen} onClick={toggleChat} />

      {isOpen && (
        <ChatWindow
          logoUrl={logoUrl}
          onClose={toggleChat}
          showDisclaimer={showDisclaimer}
          onDismissDisclaimer={handleDismissDisclaimer}
        />
      )}
    </>
  );
}
